import { create } from 'zustand';
import type { FinalSong } from '../interfaces/final-song';

// Port of src/app/services/i-frame-audio-player-state.service.ts.
// Angular's `selectedSongSignal` is named `selectedSong` here; the plain
// (non-signal) fields playingAudioElement / songPosition are kept as state
// fields (they were never observed reactively in Angular, only read).
interface PlayerState {
  selectedSong: FinalSong | undefined;
  playingIframeId: string | undefined;
  playingAudioUrl: string | undefined;
  songPlayedFromPlaylist: boolean;

  playingAudioElement: HTMLAudioElement | undefined;
  songPosition: number | undefined;

  setPlayingIframe: (youtube_id: string | undefined) => void;
  setPlayingAudio: (url: string | undefined, audioElement: HTMLAudioElement | undefined) => void;
  setSongAndPosition: (song: FinalSong | undefined, position: number | undefined) => void;
  playSongFromPlaylist: (song: FinalSong) => void;
}

export const usePlayerStore = create<PlayerState>()((set) => ({
  selectedSong: undefined,
  playingIframeId: undefined,
  playingAudioUrl: undefined,
  songPlayedFromPlaylist: false,

  playingAudioElement: undefined,
  songPosition: undefined,

  setPlayingIframe: (youtube_id) => set({
    playingAudioElement: undefined,
    playingIframeId: youtube_id,
    playingAudioUrl: undefined,
  }),

  setPlayingAudio: (url, audioElement) => set({
    playingAudioElement: audioElement,
    playingIframeId: undefined,
    playingAudioUrl: url,
    songPlayedFromPlaylist: false,
  }),

  setSongAndPosition: (song, position) => set({
    selectedSong: song,
    songPosition: position,
    songPlayedFromPlaylist: false,
  }),

  playSongFromPlaylist: (song) => set({
    selectedSong: song,
    songPlayedFromPlaylist: true,
  }),
}));
